import { render, staticRenderFns } from "./KIconButton.vue?vue&type=template&id=229d0d57&scoped=true"
import script from "./KIconButton.vue?vue&type=script&lang=js"
export * from "./KIconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d0d57",
  null
  
)

export default component.exports